import { render, staticRenderFns } from "./ActionsList.vue?vue&type=template&id=5b55c964"
import script from "./ActionsList.vue?vue&type=script&lang=js"
export * from "./ActionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports